import { useEffect, useState } from 'react';

const SEARCH_DELAY_MS = 300;

/** Сколько вариантов просим у сервера: список выбора, а не каталог */
export const SEARCH_PAGE_SIZE = 20;

/**
 * Поиск на сервере по мере ввода с задержкой; ответ на устаревший ввод отбрасывается.
 * `search` должна быть стабильной (action.bound стора, функция модуля или useCallback).
 * `enabled: false` — не ищем, пока список закрыт: на экране много выборов, открывают единицы
 */
export const useServerSearch = <T>({
  search,
  enabled = true,
}: {
  search: (query: string) => Promise<T[]>;
  enabled?: boolean;
}) => {
  const [query, setQuery] = useState('');
  const [options, setOptions] = useState<T[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!enabled) return;

    let isActual = true;

    setIsLoading(true);

    const timer = setTimeout(async () => {
      const found = await search(query);

      if (!isActual) return;

      setOptions(found);
      setIsLoading(false);
    }, SEARCH_DELAY_MS);

    return () => {
      isActual = false;
      clearTimeout(timer);
    };
  }, [search, query, enabled]);

  return { query, setQuery, options, isLoading };
};
